import { ApplyAutomationProgressBanner } from "#src/batteries-included-components/Banners/ApplyAutomationProgressBanner";
import { RecordsViewFilterArea } from "#src/batteries-included-components/FilterAreas/RecordsFilterAreas";
import { DefaultRecordValueConfigTablePanel } from "#src/batteries-included-components/Panels/TablePanels/DefaultRecordValueConfigTablePanel";
import { RecordsTablePanel } from "#src/batteries-included-components/Panels/TablePanels/RecordsTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { ButtonToggleGroup } from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import React, { useState } from "react";
import { FacilityUpdateStatusBanner } from "./FacilityUpdateStatusBanner";

export const FacilityRecordsTabContent = ({
  facilityId,
}: {
  facilityId: string;
}) => {
  const [filterConfigStorageKey, viewConfigStorageKey] = useStorageKey(
    ["filter-configuration", "view-configuration"],
    ["records", "list", "facilities"]
  );
  const [tableConfigStorageKey, tableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "list", "facilities", facilityId]
  );
  const [applySeededAutomationJobStorageKey] = useStorageKey(
    ["async-job"],
    "facility-seeded-automation-job-configuration"
  );
  const [drvcTableConfigStorageKey, drvcTableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "default-record-value-configuration", "list", "facilities"]
  );
  const [mode, setMode] = useState<"records" | "automation">("records");

  return (
    <>
      <FacilityUpdateStatusBanner />
      <div
        style={{
          marginRight: 8,
          display: "flex",
          gap: 8,
          marginBottom: 16,
          alignItems: "center",
        }}
      >
        <ButtonToggleGroup
          activeKey={mode}
          items={[
            { label: "Records", dataKey: "records" },
            { label: "Default Automations", dataKey: "automation" },
          ]}
          onChange={(val) => setMode(val as "records" | "automation")}
          name="records-switcher"
        />
        <RecordsViewFilterArea
          viewConfigStorageKey={viewConfigStorageKey}
          isPeriodDateRange={true}
          isPeriodAvailable={mode === "records"}
        />
      </div>
      {mode === "records" && (
        <>
          <ApplyAutomationProgressBanner
            jobStorageKey={applySeededAutomationJobStorageKey}
            showCounts={false}
          />
          <RecordsTablePanel
            type={AssetType.FACILITY}
            filterConfigStorageKey={filterConfigStorageKey}
            tableConfigStorageKey={tableConfigStorageKey}
            viewConfigStorageKey={viewConfigStorageKey}
            applySeededAutomationJobStorageKey={
              applySeededAutomationJobStorageKey
            }
            tableStateStorageKey={tableStateStorageKey}
          />
        </>
      )}
      {mode === "automation" && (
        <DefaultRecordValueConfigTablePanel
          type={AssetType.FACILITY}
          tableConfigStorageKey={drvcTableConfigStorageKey}
          viewConfigStorageKey={viewConfigStorageKey}
          tableStateStorageKey={drvcTableStateStorageKey}
        />
      )}
    </>
  );
};
